import { render, staticRenderFns } from "./forkModel.vue?vue&type=template&id=210a6bd0&scoped=true"
import script from "./forkModel.vue?vue&type=script&lang=js"
export * from "./forkModel.vue?vue&type=script&lang=js"
import style0 from "./forkModel.vue?vue&type=style&index=0&id=210a6bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210a6bd0",
  null
  
)

export default component.exports